export const isType = (variable, type) => typeof variable === type;

export const Debounce = (func, wait) => {
  let timer = null;
  function callbackDebounce() {
    if (!timer) {
      clearTimeout(timer);
      timer = setTimeout(func, wait);
    }
  }
  return callbackDebounce();
};

export const FormatCurrency = (currency, country, type) => {
  const config = {
    style: 'currency',
    currency: type || 'BRL',
    minimumIntegerDigits: 2,
    maximumIntegerDigits: 5,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  const value = parseFloat(currency || 0);
  return value.toLocaleString(country || 'pt-BR', config);
};

export const GenerateArray = (arr, callback) => Array.from({ length: arr.length }, callback);

export const ArrUniq = (array, fn) => [...new Set(array?.map(fn))]?.map(row => array?.find(item => fn(item) === row));

export const searchInArray = (field, condition, truthValue) => obj => {
  switch (condition) {
    case 'biggerThan':
      return obj[field] > truthValue;
    case 'smallerThan':
      return obj[field] < truthValue;
    case 'biggerOrEqual':
      return obj[field] >= truthValue;
    case 'smallerOrEqual':
      return obj[field] <= truthValue;
    case 'isEqual':
      return obj[field] === truthValue;
    case 'isDiff':
      return obj[field] !== truthValue;
    default:
      return obj[field] === truthValue;
  }
};

export const arabicToRoman = number => {
  let roman = '';
  const romanNumList = {
    M: 1000,
    CM: 900,
    D: 500,
    CD: 400,
    C: 100,
    XC: 90,
    L: 50,
    XV: 40,
    X: 10,
    IX: 9,
    V: 5,
    IV: 4,
    I: 1,
  };
  let a;
  if (number > 3999) return 'Enter a number between 1 and 3999';

  for (const key in romanNumList) {
    a = Math.floor(number / romanNumList[key]);
    if (a >= 0) {
      for (let i = 0; i < a; i++) {
        roman += key;
      }
    }
    number %= romanNumList[key];
  }
};

export const romanToArabic = romanNumber => {
  romanNumber = romanNumber.toUpperCase();
  const romanNumList = ['CM', 'M', 'CD', 'D', 'XC', 'C', 'XL', 'L', 'IX', 'X', 'IV', 'V', 'I'];
  const corresp = [900, 1000, 400, 500, 90, 100, 40, 50, 9, 10, 4, 5, 1];
  let index = 0;
  let num = 0;
  for (const rn in romanNumList) {
    index = romanNumber.indexOf(romanNumList[rn]);
    while (index !== -1) {
      num += parseInt(corresp[rn]);
      romanNumber = romanNumber.replace(romanNumList[rn], '-');
      index = romanNumber.indexOf(romanNumList[rn]);
    }
  }
  return num;
};
